export default __webpack_public_path__ + "static/media/user.902395ba.svg";